function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawFollowing = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1144 673.92",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 353.62,
    y1: 340.96,
    x2: 353.62,
    y2: 273.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 356.47,
    y1: 459.96,
    x2: 356.47,
    y2: 398.96,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 195.37,
    y1: 775.43,
    x2: 195.37,
    y2: 438.78,
    gradientTransform: "matrix(-1 0 0 1 470 0)",
    xlinkHref: "#prefix__a"
  })), React.createElement("ellipse", {
    cx: 241,
    cy: 658.42,
    rx: 147.68,
    ry: 10.5,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1144 396.23a180.56 180.56 0 0 1-26.12 93.88c0 34.62-16.14 66-42.32 88.87a144.74 144.74 0 0 1-21.08 15.28c-.3.19-.61.37-.92.55-.56.33-1.12.66-1.69 1l-.53.31a164.61 164.61 0 0 1-81.1 20.84H217.17q-9 0-17.84-.72a211.15 211.15 0 0 1-61.06-14.14q-5.72-2.26-11.22-4.86-2.62-1.23-5.19-2.53c-1.07-.54-2.14-1.1-3.2-1.66a187.42 187.42 0 0 1-34.46-23.39c-34-29.23-55.08-69.61-55.08-114.21A180.5 180.5 0 0 1 0 356.74c0-99.14 79.24-179.51 177-179.51 3 0 6 .09 9 .25.43 0 .85 0 1.28.06 16.48-28.09 38.51-53.9 65-76.62C324.55 39.02 430.13-.04 547.74-.04c98.82 0 189.15 27.55 258.34 73.07A174.18 174.18 0 0 1 892 50.52c97.74 0 177 80.37 177 179.51a184.9 184.9 0 0 1-1 18.78 180 180 0 0 1 76 147.42z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M958 119.33v479.18a18.41 18.41 0 0 1-18.41 18.45H204.41a18.13 18.13 0 0 1-5.08-.72A18.38 18.38 0 0 1 186 598.51V384.67 177.48c.43 0 .85 0 1.28.06 16.48-28.09 38.51-53.9 65-76.62h687.31A18.41 18.41 0 0 1 958 119.33z",
    fill: "#fff"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#3f3d56",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    opacity: 0.7,
    d: "M260 240.92h652M260 361.42h652M260 481.92h652M260 605.42h652"
  }), React.createElement("ellipse", {
    cx: 963,
    cy: 663.42,
    rx: 147.68,
    ry: 10.5,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("rect", {
    x: 514.67,
    y: 163.15,
    width: 137.83,
    height: 35.96,
    rx: 17.98,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 523.65,
    y: 169.17,
    width: 119.86,
    height: 23.93,
    rx: 11.97,
    opacity: 0.1
  }), React.createElement("rect", {
    x: 597.23,
    y: 170.48,
    width: 43.28,
    height: 21.31,
    rx: 10.65,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 618.54,
    cy: 181.13,
    r: 6.66,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 514.67,
    y: 400.2,
    width: 137.83,
    height: 35.96,
    rx: 17.98,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 523.65,
    y: 406.22,
    width: 119.86,
    height: 23.93,
    rx: 11.97,
    opacity: 0.1
  }), React.createElement("rect", {
    x: 597.23,
    y: 407.53,
    width: 43.28,
    height: 21.31,
    rx: 10.65,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 618.54,
    cy: 418.18,
    r: 6.66,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 514.67,
    y: 518.73,
    width: 137.83,
    height: 35.96,
    rx: 17.98,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 523.65,
    y: 524.74,
    width: 119.86,
    height: 23.93,
    rx: 11.97,
    opacity: 0.1
  }), React.createElement("rect", {
    x: 597.23,
    y: 526.05,
    width: 43.28,
    height: 21.31,
    rx: 10.65,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 618.54,
    cy: 536.71,
    r: 6.66,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 514.67,
    y: 281.68,
    width: 137.83,
    height: 35.96,
    rx: 17.98,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 523.65,
    y: 287.69,
    width: 119.86,
    height: 23.93,
    rx: 11.97,
    opacity: 0.1
  }), React.createElement("rect", {
    x: 554.65,
    y: 402.04,
    width: 43.28,
    height: 21.31,
    rx: 10.65,
    transform: "rotate(180 562.29 356.18)",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 548.62,
    cy: 299.66,
    r: 6.66,
    fill: "#fff"
  }), React.createElement("path", {
    d: "M379.5 180.96a47 47 0 0 1-22.91 40.37l-.64.38-1.21.67-1.15.6-.18.09q-.72.36-1.47.69a45.82 45.82 0 0 1-4.89 1.9c-1.09.35-2.19.67-3.3.94a46.61 46.61 0 0 1-6.93 1.15c-1.42.13-2.85.2-4.3.2a49 49 0 0 1-5.17-.28h-.3a35.7 35.7 0 0 1-1.77-.23 48.61 48.61 0 0 1-5.56-1.21l-.91-.27-.8-.25-.26-.09a46.39 46.39 0 0 1-4.8-1.88 45.75 45.75 0 0 1-7.65-4.43l-.12-.08-.08-.06-.86-.63-.65-.5a44 44 0 0 1-3.64-3.17q-1.62-1.56-3.08-3.27a47 47 0 1 1 82.63-30.64z",
    fill: "#434175"
  }), React.createElement("path", {
    d: "M382.73 335.28l-1.19.36a2.63 2.63 0 0 1-1.84-.61l-.39-.37a1.46 1.46 0 0 0-.92-.51h-.1a1 1 0 0 1-.41 0 .11.11 0 0 1-.08 0 .5.5 0 0 1-.23-.4 19.64 19.64 0 0 1-.53-2.73 25.52 25.52 0 0 1 0-3v-2.38a22.18 22.18 0 0 0 .23-2.7 10.11 10.11 0 0 0-.27-2.86 8 8 0 0 0-.56-1.5c-.16-1.35-.35-2.7-.54-4-.14-1-.29-2-.47-3a4.42 4.42 0 0 0 .1-.5 4.85 4.85 0 0 0-1.72-4.38 5.26 5.26 0 0 0-1.28-.79c-.38-.16-.77-.29-1.16-.42l-6.28-2a52.31 52.31 0 0 1-1.69-2.67 18.64 18.64 0 0 1-1.32-2.55 10.37 10.37 0 0 0 2.59-13.65c-.1-.16-.22-.31-.33-.46a6.72 6.72 0 0 0-.27-2.33.14.14 0 0 0 0-.06 3.31 3.31 0 0 0-.86-1.67l-.21-.23a3.19 3.19 0 0 0-.31-.33 11.65 11.65 0 0 0-1.36-1.17c-2.08-1.56-4.87-3.46-7.41-4.09a8.49 8.49 0 0 0-3.82 0l-.2-.07-.37-.07.29.14a8.36 8.36 0 0 0-4.07.07c-1.65.51-2.23 1.86-2.93 3.34a14.92 14.92 0 0 1-5 5.9c-1.37.94-3 1.76-3.66 3.32s-.19 3.13-.06 4.71a13.09 13.09 0 0 1-4.75 11.26c-1.87 1.5-4.36 2.75-4.77 5.15-.28 1.71.65 3.35 1.36 4.92 1.49 3.34 2 7.41.25 10.6-.17.3-.35.59-.52.87.95 1.16 2 2.26 3 3.32a45.45 45.45 0 0 0 3.59 3.21l.64.51.85.63.08.07.12.08a45.06 45.06 0 0 0 7.54 4.49.49.49 0 0 1 .06-.17.68.68 0 0 0 0 .2 44.45 44.45 0 0 0 4.73 1.9l.25.09.79.26.9.27a47.31 47.31 0 0 0 5.48 1.23c.58.09 1.16.17 1.75.23h.29a47.69 47.69 0 0 0 5.1.28c1.43 0 2.84-.07 4.24-.2a44.3 44.3 0 0 0 6.83-1.17c.27-.06.54-.14.81-.22.82-.22 1.63-.46 2.44-.73a44.78 44.78 0 0 0 4.82-1.92c.49-.23 1-.46 1.45-.7l.18-.09 1.13-.61a.08.08 0 0 1-.01-.1zm-40.07-1.38a2 2 0 0 0 0-.25 4.25 4.25 0 0 1 0-.8 1.24 1.24 0 0 1 .18-.44v.48a2.71 2.71 0 0 1-.18 1.01z",
    transform: "translate(-28 -113.04)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M354.73 222.31l-1.21.36a2.71 2.71 0 0 1-1.86-.6c-.13-.11-.27-.25-.4-.37a1.46 1.46 0 0 0-.93-.5h-.1a1 1 0 0 1-.42 0 .11.11 0 0 1-.08 0 .54.54 0 0 1-.24-.4 19.09 19.09 0 0 1-.53-2.69 24.86 24.86 0 0 1 0-3v-2.35a21.69 21.69 0 0 0 .23-2.67 9.86 9.86 0 0 0-.27-2.82 8.86 8.86 0 0 0-.57-1.48c-.16-1.33-.36-2.66-.55-4-.14-1-.29-2-.48-3 0-.16.08-.32.11-.49a4.72 4.72 0 0 0-1.75-4.32 5.35 5.35 0 0 0-1.3-.78c-.38-.16-.78-.29-1.18-.42l-6.37-2c-.59-.86-1.16-1.74-1.71-2.63a17.38 17.38 0 0 1-1.34-2.52 10 10 0 0 0 2.63-13.47c-.1-.16-.22-.3-.33-.45a6.55 6.55 0 0 0-.27-2.3.14.14 0 0 0 0-.06 3.55 3.55 0 0 0-.22-.7 4.1 4.1 0 0 0-.65-.95l-.22-.23a3.11 3.11 0 0 0-.31-.32 11.77 11.77 0 0 0-1.41-1.09c-2.11-1.54-4.94-3.41-7.52-4a8.71 8.71 0 0 0-3.87 0l-.2-.06-.37-.07.29.14a8.61 8.61 0 0 0-4.13.07c-1.67.5-2.26 1.83-3 3.29a14.85 14.85 0 0 1-5 5.82c-1.39.93-3 1.74-3.71 3.28s-.2 3.09-.06 4.65a12.8 12.8 0 0 1-4.82 11.11c-1.9 1.48-4.43 2.71-4.84 5.08-.29 1.69.66 3.31 1.38 4.86 1.51 3.29 2 7.31.25 10.46-.17.29-.35.58-.53.86q1.45 1.71 3.08 3.27a44 44 0 0 0 3.64 3.17l.65.5.86.63.08.06.12.08a45.75 45.75 0 0 0 7.65 4.43.52.52 0 0 1 .06-.16 4.9 4.9 0 0 1 .24-.52 5.82 5.82 0 0 0 .89-2 2 2 0 0 0 0-.25 4.16 4.16 0 0 1 0-.79 1.27 1.27 0 0 1 .18-.43c.11-.2.27-.39.4-.59a2.17 2.17 0 0 0 .19-.33c.11.15.21.3.31.46.36.55.71 1.1 1.06 1.66a2.57 2.57 0 0 1 .52 1.28 2.09 2.09 0 0 0 0 .83c.15.35.65.64.46 1a1.32 1.32 0 0 0 0 1.18 5.56 5.56 0 0 0 .42.57l.26.09.8.25.91.27a48.61 48.61 0 0 0 5.56 1.21c.59.09 1.18.17 1.77.23h.3a49 49 0 0 0 5.17.28c1.45 0 2.88-.07 4.3-.2a46.61 46.61 0 0 0 6.93-1.15c.28-.06.55-.14.83-.22.83-.22 1.65-.45 2.47-.72a45.82 45.82 0 0 0 4.89-1.9q.75-.33 1.47-.69l.18-.09 1.15-.6z",
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M378.5 299.96a46.77 46.77 0 0 1-5.76 22.56 44.38 44.38 0 0 1-2.62 4.22 43.61 43.61 0 0 1-3.07 4 1.51 1.51 0 0 1-.21.23c-.42.5-.87 1-1.33 1.46l-.51.54c-.52.53-1.05 1-1.6 1.54a1.8 1.8 0 0 1-.2.19c-.25.23-.51.47-.78.69a45.8 45.8 0 0 1-4.42 3.43c-.79.54-1.59 1.06-2.41 1.55l-.64.38-1.21.67-.82.43-.33.17-.18.09q-.48.24-1 .45c-.17.09-.34.16-.51.24l-1 .42c-.88.38-1.78.74-2.69 1.06l-1.22.41h-.14a1.71 1.71 0 0 1-.3.09l-.23.08-.68.2-.23.07-.29.08-.42.11a1.57 1.57 0 0 1-.29.08l-.71.19c-.52.13-1.05.25-1.58.35a45.08 45.08 0 0 1-5.35.8c-1.36.12-2.72.19-4.11.2h-.32a45.7 45.7 0 0 1-3.9-.17l-1.14-.11h-.48l-1.59-.21-1.27-.22-.32-.06c-.59-.11-1.18-.23-1.76-.38a.32.32 0 0 1-.14 0c-.7-.15-1.39-.33-2.07-.52l-.91-.27-.8-.25-.26-.09a48 48 0 0 1-4.76-1.87q-1.61-.74-3.15-1.59l-.46-.26-.68-.39-.37-.22c-1-.62-2-1.28-3-2l-.12-.08-.08-.06-.86-.63-.65-.5a44 44 0 0 1-3.64-3.17q-1.62-1.56-3.08-3.27a47 47 0 1 1 82.65-30.66z",
    fill: "#434175"
  }), React.createElement("path", {
    d: "M379 454.81a1.74 1.74 0 0 0-.25-.29 1.3 1.3 0 0 0-.23-.18 2.31 2.31 0 0 1-.89-2.2 2.09 2.09 0 0 0 0-.26 13.61 13.61 0 0 0-1.16-2.95c-.25-.53-.56-1.34-.83-2.1-.36-1-.65-1.91-.65-1.91s0-.09-.05-.26c-.12-.63-.45-2.4-.74-4.06v-.29c-.37-2.14-3.91-7.81-3.91-7.81a.39.39 0 0 0-.15-.19c-.79-.37-3.49-1.92-3.49-1.92-2-2.53-3.9-3.15-5.21-3.18h-.49a3.11 3.11 0 0 0-.33 0 3.93 3.93 0 0 0-.52.13l-.19.06a1.87 1.87 0 0 0-.26.11l-.06.49a11.09 11.09 0 0 1 .28-3.62l.1-.34h.58a9.81 9.81 0 0 0 9.29-12.51v-.14l.29-.14c1.18-.45 2.7.32 3.67-.5a2.87 2.87 0 0 0 .73-1.28 7.74 7.74 0 0 0 .53-2.05 3.42 3.42 0 0 0 0-.64v-.13.05a2.38 2.38 0 0 0-.51-1.27c-.63-.75-1.69-.94-2.5-1.49a6.27 6.27 0 0 1-1.59-1.91 6.84 6.84 0 0 0-1.55-1.94 2.26 2.26 0 0 0-2.32-.38 2.73 2.73 0 0 1-.77.37 1.61 1.61 0 0 1-.84-.23c-2.75-1.31-5.95-1.08-9-.69a11.78 11.78 0 0 0-3.53.86 4.28 4.28 0 0 0-2.38 2.65c-.25.94-.06 2-.36 2.89-.2.63-.61 1.18-.84 1.79a3.94 3.94 0 0 0-.22 1.05v-.06.7a29.63 29.63 0 0 0 .69 3.65c.36 1.95.18 4.06 1 5.9a3.48 3.48 0 0 0 .32.64c-.29.63-.59 1.26-.9 1.86a4.28 4.28 0 0 0-.46-.1h-.36a1.47 1.47 0 0 0-.36 0 1.12 1.12 0 0 0-.25.11l-.1.09-.07.05a.41.41 0 0 0-.08.13.16.16 0 0 0 0 .07 1.23 1.23 0 0 0-.1.38v.1c0 .21 0 .42-.06.64s0 .25-.05.37a2.87 2.87 0 0 1-.05.31v.08c0 .12-.05.25-.08.37l-.15.45-.06.13c-.06.13-.12.26-.19.38l-.34.35a.39.39 0 0 0-.21.38l-.15.12a.51.51 0 0 0-.21.08c-.07-.16-.35-.16-1.22.9a16.54 16.54 0 0 1-4 3.1s-5.87 4.18-6.19 6.11-2.21 10.27-1.21 13.06c.13.36.38.92.71 1.6v.06s.29 1.11.75 2.75c.12.07.24.16.37.23l.68.39.46.27c1 .57 2.08 1.11 3.15 1.61a48.09 48.09 0 0 0 4.76 1.89l.26.09.8.26.91.27c.68.19 1.37.37 2.07.53a.32.32 0 0 0 .14 0c.58.15 1.17.27 1.76.38l.32.06 1.27.23 1.59.21h.48l1.14.11c1.29.11 2.58.17 3.9.17h.32c1.39 0 2.75-.08 4.11-.2a45.09 45.09 0 0 0 5.35-.81c.53-.1 1.06-.22 1.58-.36l.71-.19a1.57 1.57 0 0 0 .29-.08l.42-.11.29-.08.23-.07.68-.2.23-.09a1.71 1.71 0 0 0 .3-.09h.14l1.22-.41c.91-.33 1.81-.69 2.69-1.08l1-.42c.17-.08.34-.15.51-.25a3 3 0 0 0-.4-.61zm-19.39-26.49h-.06v-.06z",
    transform: "translate(-28 -113.04)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M351 341.83a2.18 2.18 0 0 0-.25-.28 1.3 1.3 0 0 0-.23-.18 2.26 2.26 0 0 1-.89-2.17 2.09 2.09 0 0 0 0-.26 13.31 13.31 0 0 0-1.16-2.91c-.25-.52-.56-1.32-.83-2.07-.36-1-.65-1.89-.65-1.89l-.05-.25c-.12-.63-.45-2.37-.74-4v-.29c-.37-2.11-3.91-7.71-3.91-7.71a.35.35 0 0 0-.15-.18c-.79-.37-3.49-1.9-3.49-1.9-2-2.5-3.9-3.11-5.21-3.14h-.49a3.11 3.11 0 0 0-.33 0 3.93 3.93 0 0 0-.52.13l-.19.06a1.87 1.87 0 0 0-.26.11l-.06.49a10.84 10.84 0 0 1 .28-3.58c0-.11.07-.22.1-.33h.58a9.67 9.67 0 0 0 9.67-9.67 9.49 9.49 0 0 0-.38-2.68V299l.16-.04c1.18-.44 2.7.32 3.67-.49a2.83 2.83 0 0 0 .73-1.27 7.44 7.44 0 0 0 .53-2 3.32 3.32 0 0 0 0-.63v-.13.05a2.35 2.35 0 0 0-.51-1.25c-.63-.75-1.69-.93-2.5-1.48a6 6 0 0 1-1.59-1.88 6.89 6.89 0 0 0-1.53-1.92 2.25 2.25 0 0 0-2.32-.36 3 3 0 0 1-.77.36 1.61 1.61 0 0 1-.84-.23c-2.75-1.3-5.95-1.07-9-.68a11.47 11.47 0 0 0-3.53.85 4.24 4.24 0 0 0-2.38 2.61c-.25.93-.06 1.94-.36 2.86-.2.62-.61 1.16-.84 1.77a3.65 3.65 0 0 0-.22 1v-.06.69a28.87 28.87 0 0 0 .69 3.6c.36 1.92.18 4 1 5.83a3.73 3.73 0 0 0 .32.63c-.29.62-.59 1.24-.9 1.83a4.28 4.28 0 0 0-.46-.1h-.36a1.47 1.47 0 0 0-.36 0 1.22 1.22 0 0 0-.24.1l-.1.09-.07.05a.41.41 0 0 0-.08.13.16.16 0 0 0 0 .07 1.16 1.16 0 0 0-.1.38v.1c0 .21 0 .42-.06.63s0 .25-.05.37 0 .2-.05.3 0 .05 0 .08-.05.25-.08.37l-.15.45-.06.12a3.2 3.2 0 0 1-.19.37 1.07 1.07 0 0 1-.19.13.39.39 0 0 0-.21.38l-.15.12a.46.46 0 0 0-.21.07c-.07-.15-.35-.15-1.22.89a16.48 16.48 0 0 1-4 3.06s-5.87 4.13-6.19 6-2.21 10.14-1.21 12.89c.13.36.38.91.71 1.58v.06s.29 1.1.75 2.72l.37.22.68.39.46.26q1.54.86 3.15 1.59a48 48 0 0 0 4.76 1.87l.26.09.8.25.91.27c.68.19 1.37.37 2.07.52a.32.32 0 0 0 .14 0c.58.15 1.17.27 1.76.38l.32.06 1.27.22 1.59.21h.48l1.14.11c1.29.11 2.58.17 3.9.17h.32c1.39 0 2.75-.08 4.11-.2a45.08 45.08 0 0 0 5.35-.8c.53-.1 1.06-.22 1.58-.35l.71-.19a1.57 1.57 0 0 0 .29-.08l.42-.11.29-.08.23-.07.68-.2.23-.08a1.71 1.71 0 0 0 .3-.09h.14l1.22-.41c.91-.32 1.81-.68 2.69-1.06l1-.42c.17-.08.34-.15.51-.24a3 3 0 0 0-.45-.47zm-19.39-26.14h-.06v-.06z",
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M379.5 417.96a46.77 46.77 0 0 1-5.76 22.56 44.38 44.38 0 0 1-2.62 4.22 43.61 43.61 0 0 1-3.07 4 1.51 1.51 0 0 1-.21.23c-.42.5-.87 1-1.33 1.46l-.51.54c-.52.53-1.05 1-1.6 1.54a1.8 1.8 0 0 1-.2.19c-.25.23-.51.47-.78.69a45.8 45.8 0 0 1-4.42 3.43c-.79.54-1.59 1.06-2.41 1.55l-.64.38-1.21.67-.59.31h-.07l-.16.09-.33.17-.18.09-1 .45-.51.24-1 .42-1.42.59-.75.28-.51.19-1.22.41h-.14l-.3.09-.23.08-.68.2-.23.07h-.29l-.42.11a1.57 1.57 0 0 1-.29.08l-.71.19c-.52.13-1.05.25-1.58.35a45.653 45.653 0 0 1-5.35.8c-1.36.12-2.72.19-4.11.2h-.32a45.7 45.7 0 0 1-3.9-.17l-1.14-.11h-.48c-.48 0-1-.12-1.44-.19h-.15l-1.27-.22-.32-.06c-.59-.11-1.18-.23-1.76-.38a.32.32 0 0 1-.14 0c-.7-.15-1.39-.33-2.07-.52l-.91-.27-.8-.25-.26-.09-.73-.25-.51-.18c-.37-.13-.73-.27-1.09-.42l-.37-.15-.47-.19q-.78-.32-1.53-.66-1.61-.73-3.15-1.59l-.46-.26-.68-.39-.37-.22c-.5-.31-1-.62-1.49-1-.5-.33-1-.66-1.46-1l-.12-.08-.08-.06-.86-.63-.65-.5a44 44 0 0 1-3.64-3.17q-1.62-1.56-3.08-3.27a47 47 0 1 1 82.53-30.59z",
    fill: "#434175"
  }), React.createElement("g", {
    opacity: 0.3,
    fill: primaryColor
  }, React.createElement("path", {
    d: "M345.29 463.16l.03-.01-.03.01zM352.8 457.3a.58.58 0 0 1-.29-.2 1.65 1.65 0 0 1 .87-.5c.31-.08.48-.54.44-1a1.69 1.69 0 0 0-.37-1.25.88.88 0 0 1-.21-.35 8.74 8.74 0 0 1 .59-1.08.34.34 0 0 0 0-.34c.28-.69-1-.56-1-.56v-6.57s-.1-.53-.24-1.54-.34-2.49-.53-4.38c-.38-3.77-1.87-4.16-1.87-4.16a16.91 16.91 0 0 1-2.32-.91 15.85 15.85 0 0 0-2.44-.91 12.52 12.52 0 0 1-3.16-.44 9.66 9.66 0 0 0-2.15-.46l-.23-.12a8.33 8.33 0 0 1-3.86-4 8.1 8.1 0 0 0 .86-1.16v.75c1-1.8 4-2.21 4.29-4.26v-.07a2.35 2.35 0 0 0 0-.53 2.28 2.28 0 0 0 0-.26v-.21c0-.51-.2-1-.26-1.55v-.1a3.54 3.54 0 0 1 .08-.45.89.89 0 0 1 0-.14 4.13 4.13 0 0 1 .15-.5c.42-1.13 1.2-2.19 1.62-3.35a5.54 5.54 0 0 0 .21-.8v-.11a6.82 6.82 0 0 0 .08-.79v-.13-.37.09-.15a.13.13 0 0 0 0-.07.34.34 0 0 0 0-.1 2.62 2.62 0 0 0 0-.28 6.08 6.08 0 0 0-2-4.4c-1-.89-2.38-1.45-3.09-2.61-.33-.55-.49-1.18-.86-1.71a4.29 4.29 0 0 0-3.11-1.53 17.34 17.34 0 0 1-3.53-.47c-.81-.26-1.53-.73-2.34-1a4.48 4.48 0 0 0-4.82 1.73 8.09 8.09 0 0 1-1.28 1.86c-1.18 1-3.18.57-4.22 1.72a2.87 2.87 0 0 0-.56 2.19v.55a.49.49 0 0 1 0 .12 2.56 2.56 0 0 0 0 .39V411.24c0 .26.07.52.1.77a11.73 11.73 0 0 1 .1 1.32v.2a13.69 13.69 0 0 1-1.49 5.78c-1 1.91-2.42 3.67-2.67 5.81a4.82 4.82 0 0 0 0 .93v-.09a1.33 1.33 0 0 0 0 .2v1.15l.09.48a2.38 2.38 0 0 0 0 .26l.15.62v.11c.28 1 .65 2.08.87 3.13a10.13 10.13 0 0 1 .18 1.08.28.28 0 0 0 0 .09c0 .3.05.61.06.91s0 0 0 .08v.16a11.69 11.69 0 0 1-1.5.46c-.9.13-3.54 2.47-3.35 3.05a.83.83 0 0 1 0 .25.92.92 0 0 1 0 .16 38.58 38.58 0 0 1-1.22 4.35l-2.12 14.61c.49.33 1 .64 1.49 1l.37.22.68.39.46.26q1.54.85 3.15 1.59.75.35 1.53.66l.47.19.37.15a1.63 1.63 0 0 0 .6.37h.43a1 1 0 0 0 .3 0h.16l.51.18.73.25.26.09.8.25.91.27c.68.19 1.37.37 2.07.52a.32.32 0 0 0 .14 0c.58.15 1.17.27 1.76.38l.32.06 1.27.22h.15c.48.07 1 .14 1.44.19h.48l1.14.11c1.29.11 2.58.17 3.9.17h.32c1.39 0 2.75-.08 4.11-.2.92-.08 1.84-.19 2.75-.33s1.74-.29 2.6-.47c.53-.1 1.06-.22 1.58-.35l.71-.19a1.57 1.57 0 0 0 .29-.08l.42-.11h.12c0-.68-.08-1.26-.1-1.71.15.2.3.37.4.5a.5.5 0 0 1 .11.22 4.11 4.11 0 0 0-.37 1h.09l.23-.07.68-.2.23-.08.3-.09h.14l1.22-.41.51-.19.75-.28 1.42-.59 1-.42.51-.24 1-.45.18-.09.33-.17.16-.09h.07a4.32 4.32 0 0 0 0-.7v-.36c.06-.27-.46-.86-1.3-1.18zm-37.9-23.29zM308.41 461.59l-.18-.08a.62.62 0 0 0 .18.08z"
  })), React.createElement("path", {
    d: "M379.5 536.96a46.77 46.77 0 0 1-5.76 22.56 44.38 44.38 0 0 1-2.62 4.22 43.61 43.61 0 0 1-3.07 4 .89.89 0 0 1-.19.2c-.42.5-.87 1-1.33 1.46l-.14.15-.37.39c-.52.53-1.05 1-1.6 1.54a1.8 1.8 0 0 1-.2.19c-.25.23-.51.47-.78.69-1 .92-2.13 1.79-3.26 2.61l-.2.14-.41.29c-.18.14-.36.26-.55.39-.79.54-1.59 1.06-2.41 1.55l-.36.22-.28.16-1.21.67-.59.31h-.07l-.16.09-.33.17-.18.09-1 .45-.51.24-1 .42-1.42.59-.75.28-.51.19-.2.07-1 .34h-.14l-.3.09-.23.08-.27.08-.41.12-.23.07h-.29l-.42.11a1.57 1.57 0 0 1-.29.08l-.71.19c-.52.13-1.05.25-1.58.35-.86.18-1.73.34-2.6.47q-.78.12-1.56.21h-.19l-1 .1c-1.36.12-2.72.19-4.11.2h-1.14c-1 0-2.06-.07-3.08-.16h-.3l-.84-.08h-.48l-1-.12-.48-.07h-.15l-1.27-.22-.32-.06-.84-.16-.35-.08-.57-.14a.32.32 0 0 1-.14 0c-.7-.15-1.39-.33-2.07-.52l-.36-.11h-.13l-.42-.12-.39-.12-.41-.13-.26-.09-.73-.25-.51-.18-.47-.21-.61-.24-.37-.15-.47-.19q-.78-.32-1.53-.66c-.79-.36-1.57-.74-2.33-1.16-.28-.13-.55-.28-.82-.43l-.21-.12-.24-.13-.68-.39-.37-.22c-.5-.31-1-.62-1.49-1-.5-.33-1-.66-1.46-1l-.12-.08-.08-.06-.41-.3-.45-.33-.08-.06c-.19-.15-.39-.29-.57-.44a44 44 0 0 1-3.64-3.17q-1.62-1.56-3.08-3.27a47 47 0 1 1 82.51-30.6z",
    fill: "#434175"
  }), React.createElement("path", {
    d: "M362.79 557.96a1.55 1.55 0 0 0-2.08-.68l-13.69 7a1.62 1.62 0 0 0-.17-.53 1.25 1.25 0 0 0-.56-1 .93.93 0 0 1-.3-.29 2.9 2.9 0 0 1 0-.31.9.9 0 0 0-.16-.71 1.76 1.76 0 0 0-.75-1.28h-.05v-.35a1.39 1.39 0 0 0-.19-.63c-.05-.65-.52-1.25-1.46-2.14a3.33 3.33 0 0 1-.75-1.34v-.06c-.17-.65-.34-1.38-.58-2.12a11.9 11.9 0 0 0-.4-1.24c-.74-1.91-1.55-1.66-1.88-2s-2.48-.77-3.58-1.34c-.93-.48-4 0-4.94.22v-.19a9.26 9.26 0 0 0 6.4-10.78l-.06-.23a3.74 3.74 0 0 0 1.42-.28 1.86 1.86 0 0 0 .65-1.2 6 6 0 0 0 .18-2.68c0-.09-.08-.18-.11-.27a1.55 1.55 0 0 0-.07-.23 1 1 0 0 0 0-.24 3.85 3.85 0 0 0-.31-.82.14.14 0 0 1 0 .07 28.75 28.75 0 0 0-2.3-3.09c-.8-1.2-1.26-2.72-2.47-3.52a5 5 0 0 0-4.13-.21 11.76 11.76 0 0 1-1.94.5 20.5 20.5 0 0 1-3.31-.2 7.13 7.13 0 0 0-4.4 1.17 2.47 2.47 0 0 0-.72.72 3.76 3.76 0 0 0-.32 1.3 6.33 6.33 0 0 1-.86 2.37c-.34.58-.77 1.09-1.08 1.68a2.58 2.58 0 0 0-.29 1.93c.11.34.31.64.39 1a3.65 3.65 0 0 1-.7 2.28 4.34 4.34 0 0 0-.48 2.17 2.8 2.8 0 0 0 .61 1.57 2.22 2.22 0 0 0 .2.41l.05.07a2.83 2.83 0 0 0 .2.28l.1.1.2.2a3.36 3.36 0 0 0 1.95.61 3.24 3.24 0 0 0 .17.32v.18a1 1 0 0 0 0 .17c-.06 0-2.06.27-2.7 1.11a3.89 3.89 0 0 1-2.37 1s-1.95.65-1.91.82-.57.4-1.8.73-3.25 1.5-3.25 1.79-3.22 3.45-3.22 3.78a8 8 0 0 0-.86 3.69c.12 2.16.25 4.88-.24 5.33s0 2.19 0 2.19a1.22 1.22 0 0 1 0 1.3c-.41.74.08 3.78.08 3.78v3.17a7.33 7.33 0 0 1 .18 1.38l.08.06.45.33.41.3.08.06.12.08c.48.34 1 .67 1.46 1 .49.33 1 .64 1.49 1l.37.22.68.39.24.13.21.12c.27.15.54.3.82.43.76.42 1.54.8 2.33 1.16q.75.35 1.53.66l.47.19.37.15.61.24.48.18.51.18.73.25.26.09.41.13.39.12.42.12h.13l.36.11c.68.19 1.37.37 2.07.52a.32.32 0 0 0 .14 0l.57.14.35.08.84.16.32.06 1.27.22h.15l.48.07 1 .12h.48l.84.08h.3c1 .09 2 .14 3.08.16h1.14c1.39 0 2.75-.08 4.11-.2l1-.1h.19q.78-.09 1.56-.21c.87-.13 1.74-.29 2.6-.47.53-.1 1.06-.22 1.58-.35l.71-.19a1.57 1.57 0 0 0 .29-.08l.42-.11H345.32l.23-.07.41-.12.27-.08.23-.08.3-.09h.14l1-.34.2-.07.51-.19.75-.28 1.42-.59 1-.42.51-.24 1-.45.18-.09.33-.17.16-.09h.07l.59-.31 1.21-.67.28-.16.36-.22c.82-.49 1.62-1 2.41-1.55.19-.13.37-.25.55-.39h.2l.21-.31.2-.14c1.13-.82 2.22-1.69 3.26-2.61.27-.22.53-.46.78-.69a1.8 1.8 0 0 0 .2-.19c.55-.5 1.08-1 1.6-1.54l.37-.39.14-.15c.46-.47.91-1 1.33-1.46zM340 573.64l-.25.06a.42.42 0 0 1 .08-.21s-1.53.06-3.08.18a2.29 2.29 0 0 1 .08-.77 18.34 18.34 0 0 0 .76-3.37l2.66 4.06zm.51 7.72a3.58 3.58 0 0 0 0-.4c.09-.06.15-.11.16-.15a10.16 10.16 0 0 0-.15-1.33h.24l2.81-.44s.37 0 1-.14l.23.45a14.46 14.46 0 0 0-3.6 1.61c-.07.13-.32.27-.67.4z",
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M858.89 166.82l-4-4a2.11 2.11 0 0 0-3 0l-24.86 24.66-10.52-10.6a2.09 2.09 0 0 0-3 0l-4 4a2.12 2.12 0 0 0 0 3l16 16.09a2.12 2.12 0 0 0 3 0l30.34-30.11a2.11 2.11 0 0 0 .04-3.04zM858.89 283.96l-4-4a2.11 2.11 0 0 0-3 0l-24.81 24.7-10.52-10.6a2.09 2.09 0 0 0-3 0l-4 4a2.12 2.12 0 0 0 0 3l16 16.09a2.12 2.12 0 0 0 3 0l30.31-30.19a2.11 2.11 0 0 0 .02-3zM858.89 520.36l-4-4a2.12 2.12 0 0 0-3 0l-24.86 24.66-10.52-10.6a2.11 2.11 0 0 0-3 0l-4 4a2.11 2.11 0 0 0 0 3l16 16.09a2.13 2.13 0 0 0 3 0l30.34-30.12a2.09 2.09 0 0 0 .04-3.03z",
    fill: "#3acc6c"
  }), React.createElement("ellipse", {
    cx: 172.24,
    cy: 197.08,
    rx: 13.5,
    ry: 27.08,
    transform: "rotate(-37.18 -9.783 182.19)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 172.24,
    cy: 197.08,
    rx: 13.5,
    ry: 27.08,
    transform: "rotate(-37.18 -9.783 182.19)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 172.18,
    cy: 197.13,
    rx: 12.41,
    ry: 26.38,
    transform: "rotate(-37.18 -9.852 182.25)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M128.12 63.41a121.71 121.71 0 0 0 19.26 27.91c1.46 1.57 3 3.11 4.44 4.65l8.35 8.6",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 136.24,
    cy: 152.08,
    rx: 13.5,
    ry: 27.08,
    transform: "rotate(-37.18 -45.783 137.202)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 136.24,
    cy: 152.08,
    rx: 13.5,
    ry: 27.08,
    transform: "rotate(-37.18 -45.783 137.202)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 136.18,
    cy: 152.13,
    rx: 12.41,
    ry: 26.38,
    transform: "rotate(-37.18 -45.848 137.247)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M92.12 18.41a121.71 121.71 0 0 0 19.26 27.91c1.46 1.57 3 3.11 4.44 4.65l8.35 8.6",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 172.09,
    cy: 160.15,
    rx: 23.12,
    ry: 11.53,
    transform: "rotate(-37.19 -9.876 145.256)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 172.09,
    cy: 160.15,
    rx: 23.12,
    ry: 11.53,
    transform: "rotate(-37.19 -9.876 145.256)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 172.05,
    cy: 160.1,
    rx: 22.53,
    ry: 10.6,
    transform: "rotate(-37.19 -9.926 145.206)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M161.71 33.34a104 104 0 0 0-23.83 16.45c-1.35 1.25-2.67 2.52-4 3.8l-7.34 7.13",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 135.62,
    cy: 186.84,
    rx: 23.12,
    ry: 11.53,
    transform: "rotate(-29.9 -90.026 182.767)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 135.62,
    cy: 186.84,
    rx: 23.12,
    ry: 11.53,
    transform: "rotate(-29.9 -90.026 182.767)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 135.59,
    cy: 186.78,
    rx: 22.53,
    ry: 10.6,
    transform: "rotate(-29.9 -90.054 182.72)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M88.08 84.67a103.76 103.76 0 0 1 24.43-15.55c1.67-.75 3.35-1.47 5-2.18l9.43-4",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 147.57,
    cy: 167.13,
    rx: 4.97,
    ry: 9.96,
    transform: "rotate(-37.72 -31.892 151.593)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 147.57,
    cy: 167.13,
    rx: 4.97,
    ry: 9.96,
    transform: "rotate(-37.72 -31.892 151.593)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 147.59,
    cy: 167.12,
    rx: 4.57,
    ry: 9.7,
    transform: "rotate(-37.72 -31.872 151.583)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M113.79 46.39a45.07 45.07 0 0 1 8.06 9.52c.42.66.83 1.34 1.23 2l2.25 3.79",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 159.98,
    cy: 183.12,
    rx: 4.97,
    ry: 9.96,
    transform: "rotate(-37.72 -19.474 167.587)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 159.98,
    cy: 183.12,
    rx: 4.97,
    ry: 9.96,
    transform: "rotate(-37.72 -19.474 167.587)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 160.01,
    cy: 183.1,
    rx: 4.57,
    ry: 9.7,
    transform: "rotate(-37.72 -19.449 167.563)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M126.2 62.37a44.78 44.78 0 0 1 8.06 9.52c.43.67.83 1.34 1.23 2l2.26 3.79",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 125.85,
    cy: 62.16,
    r: 2.02,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 125.85,
    cy: 62.16,
    r: 2.02,
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("path", {
    d: "M962.65 663.13c-.27-1.39-6.53-34.37 12.3-78 7.37-17.07 6.76-31.78-1.79-43.71a42.4 42.4 0 0 0-15-12.9l2.22-4.92a47.69 47.69 0 0 1 17.2 14.68c6.69 9.33 12.53 25.4 2.36 49-18.17 42.14-12 74.53-12 74.85z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M990.7 581.78c7.58-.65 13.88-1.36 14.08 1s-5.77 6.89-13.34 7.54-13.88-.74-14.08-3.1 5.77-4.79 13.34-5.44z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M990.7 581.78c7.58-.65 13.88-1.36 14.08 1s-5.77 6.89-13.34 7.54-13.88-.74-14.08-3.1 5.77-4.79 13.34-5.44z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M990.73 581.8c7.38-.63 13.5-1.61 13.67.4s-5.67 6.23-13.05 6.86-13.5-.48-13.67-2.48 5.67-4.14 13.05-4.78z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M977.79 586.66a106.59 106.59 0 0 0 17.19-1c1.08-.15 2.15-.32 3.22-.49 2-.31 4-2.72 6-3",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("path", {
    d: "M977.42 625.8c7.57-.64 13.88-1.35 14.08 1s-5.77 6.9-13.35 7.55-13.87-.74-14.08-3.1 5.78-4.8 13.35-5.45z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M977.42 625.8c7.57-.64 13.88-1.35 14.08 1s-5.77 6.9-13.35 7.55-13.87-.74-14.08-3.1 5.78-4.8 13.35-5.45z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M977.45 625.83c7.38-.63 13.5-1.61 13.67.39s-5.67 6.24-13 6.87-13.5-.48-13.67-2.48 5.62-4.15 13-4.78z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M964.51 630.69a107.81 107.81 0 0 0 17.19-1c1.08-.15 2.15-.32 3.22-.49 2-.31 4-2.72 6-3",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("path", {
    d: "M966.06 577.89c-7.09-2.75-12.94-5.2-13.8-3s3.6 8.24 10.68 11 13.53 3.2 14.39 1-4.19-6.24-11.27-9z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M966.06 577.89c-7.09-2.75-12.94-5.2-13.8-3s3.6 8.24 10.68 11 13.53 3.2 14.39 1-4.19-6.24-11.27-9z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M966 577.96c-6.9-2.68-12.5-5.35-13.23-3.47s3.69 7.58 10.59 10.26 13.09 3.34 13.82 1.47-4.26-5.62-11.18-8.26z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M977.07 586.21a107 107 0 0 1-16.21-5.82c-1-.45-2-.92-3-1.38-1.83-.86-3.07-3.73-4.89-4.6",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("path", {
    d: "M954.24 622.03c-7.09-2.76-12.94-5.21-13.8-3s3.6 8.24 10.69 11 13.52 3.2 14.38 1-4.19-6.25-11.27-9z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M954.24 622.03c-7.09-2.76-12.94-5.21-13.8-3s3.6 8.24 10.69 11 13.52 3.2 14.38 1-4.19-6.25-11.27-9z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M954.2 622.04c-6.9-2.68-12.5-5.34-13.23-3.47s3.69 7.58 10.59 10.27 13.09 3.34 13.82 1.46-4.28-5.57-11.18-8.26z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M965.25 630.35a108.15 108.15 0 0 1-16.25-5.83c-1-.45-2-.91-2.95-1.38-1.82-.86-3.06-3.73-4.89-4.59",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("path", {
    d: "M951.56 631.2c-7.22 2.37-13.3 4.19-12.56 6.45s8 4.07 15.24 1.7 12.47-6.12 11.76-8.39-7.22-2.14-14.44.24z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M951.56 631.2c-7.22 2.37-13.3 4.19-12.56 6.45s8 4.07 15.24 1.7 12.47-6.12 11.76-8.39-7.22-2.14-14.44.24z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M951.54 631.23c-7 2.31-13 3.81-12.42 5.73s7.66 3.51 14.7 1.2 12.23-5.74 11.6-7.65-6.84-1.55-13.88.72z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M965.35 630.62a106.41 106.41 0 0 1-16.22 5.8l-3.15.81c-2 .5-4.74-.93-6.7-.44",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 1014.1,
    cy: 642.46,
    rx: 10.64,
    ry: 21.35,
    transform: "rotate(-76.34 928.282 603.746)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 1014.1,
    cy: 642.46,
    rx: 10.64,
    ry: 21.35,
    transform: "rotate(-76.34 928.282 603.746)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 1014.09,
    cy: 642.52,
    rx: 9.79,
    ry: 20.79,
    transform: "rotate(-76.34 928.266 603.806)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M966 524.84a95.79 95.79 0 0 0 25.66 7.46c1.68.24 3.36.44 5 .64l9.38 1.1",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 993.19,
    cy: 614.94,
    rx: 21.35,
    ry: 10.64,
    transform: "rotate(-77.24 908.475 575.936)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 993.19,
    cy: 614.94,
    rx: 21.35,
    ry: 10.64,
    transform: "rotate(-77.24 908.475 575.936)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 993.25,
    cy: 614.95,
    rx: 20.79,
    ry: 9.79,
    transform: "rotate(-77.24 908.534 575.952)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M960.92 522.1a95.85 95.85 0 0 0 7.08-25.79c.22-1.67.39-3.36.56-5l1-9.4",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 982.55,
    cy: 661.3,
    rx: 21.35,
    ry: 10.64,
    transform: "rotate(-77.24 897.837 622.302)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 982.55,
    cy: 661.3,
    rx: 21.35,
    ry: 10.64,
    transform: "rotate(-77.24 897.837 622.302)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 982.6,
    cy: 661.31,
    rx: 20.79,
    ry: 9.79,
    transform: "rotate(-77.24 897.89 622.314)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M950.28 568.46a96.21 96.21 0 0 0 7.06-25.79c.21-1.67.39-3.36.56-5l1-9.4",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 962.24,
    cy: 631.33,
    rx: 10.64,
    ry: 21.35,
    transform: "rotate(-76.34 876.41 592.61)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 962.24,
    cy: 631.33,
    rx: 10.64,
    ry: 21.35,
    transform: "rotate(-76.34 876.41 592.61)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 962.23,
    cy: 631.39,
    rx: 9.79,
    ry: 20.79,
    transform: "rotate(-76.34 876.401 592.675)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M914.11 513.7a95.77 95.77 0 0 0 25.67 7.47c1.67.24 3.35.44 5 .64l9.39 1.1",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 999.57,
    cy: 652.5,
    rx: 9.1,
    ry: 18.25,
    transform: "rotate(-37.18 817.639 637.629)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 999.57,
    cy: 652.5,
    rx: 9.1,
    ry: 18.25,
    transform: "rotate(-37.18 817.639 637.629)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 999.53,
    cy: 652.53,
    rx: 8.37,
    ry: 17.78,
    transform: "rotate(-37.18 817.594 637.663)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M960.7 525.55a82.05 82.05 0 0 0 13 18.81c1 1.06 2 2.1 3 3.14l5.63 5.79",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 975.31,
    cy: 622.17,
    rx: 9.1,
    ry: 18.25,
    transform: "rotate(-37 801.465 610.055)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 975.31,
    cy: 622.17,
    rx: 9.1,
    ry: 18.25,
    transform: "rotate(-37 801.465 610.055)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 975.27,
    cy: 622.2,
    rx: 8.37,
    ry: 17.78,
    transform: "rotate(-37.18 793.328 607.328)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M936.44 495.22a81.74 81.74 0 0 0 13 18.81c1 1.07 2 2.1 3 3.14l5.63 5.79",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 999.47,
    cy: 627.61,
    rx: 15.58,
    ry: 7.77,
    transform: "rotate(-37.19 817.609 612.733)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 999.47,
    cy: 627.61,
    rx: 15.58,
    ry: 7.77,
    transform: "rotate(-37.19 817.609 612.733)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 999.44,
    cy: 627.57,
    rx: 15.18,
    ry: 7.14,
    transform: "rotate(-37.19 817.589 612.693)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M983.34 505.29a69.81 69.81 0 0 0-16.06 11.09c-.91.83-1.79 1.69-2.68 2.55l-5 4.81",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 974.89,
    cy: 645.6,
    rx: 15.58,
    ry: 7.77,
    transform: "rotate(-29.9 749.377 641.57)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 974.89,
    cy: 645.6,
    rx: 15.58,
    ry: 7.77,
    transform: "rotate(-29.9 749.377 641.57)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 974.87,
    cy: 645.56,
    rx: 15.18,
    ry: 7.14,
    transform: "rotate(-29.9 749.368 641.527)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M933.72 539.88a70.05 70.05 0 0 1 16.47-10.48c1.12-.51 2.26-1 3.39-1.47l6.36-2.69",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 982.94,
    cy: 632.31,
    rx: 3.35,
    ry: 6.71,
    transform: "rotate(-37.72 803.476 616.78)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 982.94,
    cy: 632.31,
    rx: 3.35,
    ry: 6.71,
    transform: "rotate(-37.72 803.476 616.78)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 982.96,
    cy: 632.3,
    rx: 3.08,
    ry: 6.54,
    transform: "rotate(-37.72 803.495 616.771)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M951.05 514.08a30.37 30.37 0 0 1 5.43 6.42c.28.45.56.9.83 1.36l1.52 2.55",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 991.31,
    cy: 643.09,
    rx: 3.35,
    ry: 6.71,
    transform: "rotate(-37.72 811.843 627.55)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 991.31,
    cy: 643.09,
    rx: 3.35,
    ry: 6.71,
    transform: "rotate(-37.72 811.843 627.55)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 991.32,
    cy: 643.07,
    rx: 3.08,
    ry: 6.54,
    transform: "rotate(-37.72 811.863 627.54)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M959.41 524.85a30.12 30.12 0 0 1 5.44 6.42c.28.45.55.9.82 1.36l1.52 2.55",
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 959.18,
    cy: 524.71,
    r: 1.36,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 959.18,
    cy: 524.71,
    r: 1.36,
    fill: "#407d3b",
    opacity: 0.3
  }), React.createElement("g", {
    opacity: 0.1,
    fill: primaryColor
  }, React.createElement("path", {
    d: "M121.24 594.35a121.19 121.19 0 0 1 .28-23.26c0-.35.07-.71.11-1.07.07-.64.15-1.29.23-1.95 0-.2 0-.41.08-.62.09-.77.2-1.56.32-2.36a.25.25 0 0 1 0-.08 157.64 157.64 0 0 1 10.64-38.11l.38-.89c.13-.31.26-.63.4-.95s.16-.36.23-.54.13-.3.19-.45c.34-.82.66-1.62 1-2.41v-.1c4.77-12.68 4.78-23 2.69-31.18-.07-.28-.14-.55-.22-.82a41.05 41.05 0 0 0-6.22-13l-.47-.63c-.31-.43-.64-.85-1-1.26a48.28 48.28 0 0 0-10.08-9.38l-.62-.42c-.32-.22-.63-.42-.92-.6s-.53-.34-.77-.48c-.45-.28-.86-.52-1.22-.73l-.6-.32c-.79-.44-1.28-.66-1.36-.7l-.12.27-.19.41V462.87l-.1.2v.13l-.15.34v.06l-.12.28v.08l-.25.56-.51 1.12-.06.14-.12.25-.12.28-.27.59.38.19.22.12a.09.09 0 0 1 .06 0h.06l.12.06.23.12.69.39.44.25c.81.48 1.79 1.11 2.88 1.88l1 .75.48.36c.47.36 1 .76 1.45 1.17l.41.37c.28.23.57.49.85.75l.13.12c.82.76 1.65 1.58 2.47 2.48a40.46 40.46 0 0 1 3 3.68c.32.44.62.89.92 1.34a35.72 35.72 0 0 1 2.67 4.83 34.65 34.65 0 0 1 2.3 6.82 4.1 4.1 0 0 1 .1.48c1.8 8.39.63 17.76-3.51 28a.49.49 0 0 1 0 .11c-.22.54-.44 1.08-.68 1.63v.07c-.06.13-.12.27-.17.4l-.7 1.66c-.15.35-.29.7-.43 1a163.29 163.29 0 0 0-10.52 38v.1c-.11.75-.22 1.49-.31 2.22v.23a.34.34 0 0 0 0 .1v.18c-.07.58-.14 1.16-.2 1.73l-.06.56c0 .16 0 .31-.05.47q-.12 1-.21 2-.08.72-.12 1.41a125.19 125.19 0 0 0-.27 18.16z"
  }), React.createElement("path", {
    d: "M144.38 519.67c7.49-.64 13.72-1.34 13.92 1s-5.71 6.82-13.2 7.46-13.73-.73-13.93-3.06 5.71-4.76 13.21-5.4z"
  }), React.createElement("path", {
    d: "M144.38 519.67c7.49-.64 13.72-1.34 13.92 1s-5.71 6.82-13.2 7.46-13.73-.73-13.93-3.06 5.71-4.76 13.21-5.4z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M144.4 519.7c7.3-.63 13.36-1.6 13.53.39s-5.61 6.17-12.91 6.79-13.36-.47-13.53-2.46 5.61-4.1 12.91-4.72z"
  }), React.createElement("path", {
    d: "M131.6 524.5a106.65 106.65 0 0 0 17-1l3.19-.49c2-.31 3.95-2.69 5.92-3z",
    opacity: 0.3
  }), React.createElement("path", {
    d: "M131.24 563.23c7.49-.64 13.73-1.34 13.93 1s-5.72 6.82-13.21 7.46-13.73-.73-13.96-3.07 5.74-4.75 13.24-5.39z"
  }), React.createElement("path", {
    d: "M131.24 563.23c7.49-.64 13.73-1.34 13.93 1s-5.72 6.82-13.21 7.46-13.73-.73-13.96-3.07 5.74-4.75 13.24-5.39z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M131.26 563.25c7.3-.62 13.36-1.59 13.53.39s-5.61 6.17-12.91 6.8-13.35-.48-13.52-2.48 5.64-4.08 12.9-4.71z"
  }), React.createElement("path", {
    d: "M118.46 568.06a105.5 105.5 0 0 0 17-1c1.07-.15 2.13-.32 3.19-.48 2-.31 4-2.69 5.92-3z",
    opacity: 0.3
  }), React.createElement("path", {
    d: "M120 515.83c-7-2.72-12.79-5.15-13.64-3s3.56 8.15 10.56 10.87 13.38 3.17 14.23 1-4.15-6.14-11.15-8.87z"
  }), React.createElement("path", {
    d: "M120 515.83c-7-2.72-12.79-5.15-13.64-3s3.56 8.15 10.56 10.87 13.38 3.17 14.23 1-4.15-6.14-11.15-8.87z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M120 515.85c-6.83-2.66-12.37-5.29-13.09-3.44s3.65 7.5 10.47 10.16 12.95 3.3 13.67 1.45-4.27-5.52-11.05-8.17z"
  }), React.createElement("path", {
    d: "M130.89 524.06a105.86 105.86 0 0 1-16-5.76l-2.96-1.34c-1.8-.85-3-3.69-4.84-4.54z",
    opacity: 0.3
  }), React.createElement("path", {
    d: "M108.3 559.49c-7-2.73-12.8-5.15-13.65-3s3.56 8.15 10.57 10.87 13.38 3.17 14.23 1-4.14-6.14-11.15-8.87z"
  }), React.createElement("path", {
    d: "M108.3 559.49c-7-2.73-12.8-5.15-13.65-3s3.56 8.15 10.57 10.87 13.38 3.17 14.23 1-4.14-6.14-11.15-8.87z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M108.27 559.51c-6.83-2.66-12.37-5.29-13.09-3.44s3.64 7.5 10.47 10.16 12.95 3.3 13.67 1.45-4.23-5.52-11.05-8.17z"
  }), React.createElement("path", {
    d: "M119.2 567.72a105.86 105.86 0 0 1-16-5.76l-2.92-1.37c-1.8-.85-3-3.69-4.84-4.54z",
    opacity: 0.3
  }), React.createElement("path", {
    d: "M105.65 568.56c-7.14 2.35-13.15 4.15-12.42 6.38s7.93 4 15.07 1.69 12.34-6.06 11.61-8.28-7.11-2.13-14.26.21z"
  }), React.createElement("path", {
    d: "M105.65 568.56c-7.14 2.35-13.15 4.15-12.42 6.38s7.93 4 15.07 1.69 12.34-6.06 11.61-8.28-7.11-2.13-14.26.21z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M105.63 568.6c-7 2.28-12.91 3.77-12.28 5.66s7.57 3.47 14.53 1.19 12.1-5.68 11.48-7.57-6.77-1.57-13.73.72z"
  }), React.createElement("path", {
    d: "M119.3 567.96a104.58 104.58 0 0 1-16.05 5.74c-1 .28-2.08.54-3.12.8-1.94.49-4.69-.92-6.63-.43z",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 167.83,
    cy: 580.92,
    rx: 10.53,
    ry: 21.12,
    transform: "rotate(-76.34 81.96 542.232)"
  }), React.createElement("ellipse", {
    cx: 167.83,
    cy: 580.92,
    rx: 10.53,
    ry: 21.12,
    transform: "rotate(-76.34 81.96 542.232)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 167.81,
    cy: 580.98,
    rx: 9.68,
    ry: 20.57,
    transform: "rotate(-76.34 81.944 542.291)"
  }), React.createElement("path", {
    d: "M119.91 463.34a95 95 0 0 0 25.4 7.39c1.65.24 3.32.43 5 .63l9.28 1.08z",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 147.13,
    cy: 553.69,
    rx: 21.12,
    ry: 10.53,
    transform: "rotate(-77.24 62.397 514.706)"
  }), React.createElement("ellipse", {
    cx: 147.13,
    cy: 553.69,
    rx: 21.12,
    ry: 10.53,
    transform: "rotate(-77.24 62.397 514.706)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 147.19,
    cy: 553.7,
    rx: 20.57,
    ry: 9.68,
    transform: "rotate(-77.24 62.455 514.723)"
  }), React.createElement("path", {
    d: "M114.91 460.63a95.29 95.29 0 0 0 7-25.5c.21-1.66.38-3.33.55-5l.94-9.3z",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 136.61,
    cy: 599.55,
    rx: 21.12,
    ry: 10.53,
    transform: "rotate(-77.24 51.873 560.57)"
  }), React.createElement("ellipse", {
    cx: 136.61,
    cy: 599.55,
    rx: 21.12,
    ry: 10.53,
    transform: "rotate(-77.24 51.873 560.57)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 136.66,
    cy: 599.57,
    rx: 20.57,
    ry: 9.68,
    transform: "rotate(-77.24 51.932 560.586)"
  }), React.createElement("path", {
    d: "M104.38 506.5a94.72 94.72 0 0 0 7-25.51c.21-1.66.38-3.33.55-5l.94-9.3z",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 116.52,
    cy: 569.91,
    rx: 10.53,
    ry: 21.12,
    transform: "rotate(-76.34 30.646 531.225)"
  }), React.createElement("ellipse", {
    cx: 116.52,
    cy: 569.91,
    rx: 10.53,
    ry: 21.12,
    transform: "rotate(-76.34 30.646 531.225)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 116.5,
    cy: 569.96,
    rx: 9.68,
    ry: 20.57,
    transform: "rotate(-76.34 30.635 531.278)"
  }), React.createElement("path", {
    d: "M68.6 452.33a95 95 0 0 0 25.4 7.39c1.65.24 3.32.43 5 .62l9.28 1.09z",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 153.45,
    cy: 590.85,
    rx: 9,
    ry: 18.05,
    transform: "rotate(-37.18 -28.555 575.995)"
  }), React.createElement("ellipse", {
    cx: 153.45,
    cy: 590.85,
    rx: 9,
    ry: 18.05,
    transform: "rotate(-37.18 -28.555 575.995)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 153.41,
    cy: 590.88,
    rx: 8.28,
    ry: 17.59,
    transform: "rotate(-37.18 -28.6 576.03)"
  }), React.createElement("path", {
    d: "M114.7 464.05a81.23 81.23 0 0 0 12.84 18.61c1 1 2 2.08 3 3.1l5.57 5.73z",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 129.45,
    cy: 560.84,
    rx: 9,
    ry: 18.05,
    transform: "rotate(-37.18 -52.568 545.993)"
  }), React.createElement("ellipse", {
    cx: 129.45,
    cy: 560.84,
    rx: 9,
    ry: 18.05,
    transform: "rotate(-37.18 -52.568 545.993)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 129.41,
    cy: 560.88,
    rx: 8.28,
    ry: 17.59,
    transform: "rotate(-37.18 -52.613 546.028)"
  }), React.createElement("path", {
    d: "M90.7 434.05a81 81 0 0 0 12.84 18.6c1 1.06 2 2.08 3 3.11l5.57 5.73z",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 153.35,
    cy: 566.22,
    rx: 15.42,
    ry: 7.69,
    transform: "rotate(-37.19 -28.604 551.373)"
  }), React.createElement("ellipse", {
    cx: 153.35,
    cy: 566.22,
    rx: 15.42,
    ry: 7.69,
    transform: "rotate(-37.19 -28.604 551.373)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 153.32,
    cy: 566.19,
    rx: 15.02,
    ry: 7.07,
    transform: "rotate(-37.19 -28.643 551.343)"
  }), React.createElement("path", {
    d: "M137.09 443.96a69.48 69.48 0 0 0-15.89 11c-.89.83-1.77 1.68-2.65 2.53l-4.89 4.76z",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 129.03,
    cy: 584.02,
    rx: 15.42,
    ry: 7.69,
    transform: "rotate(-29.9 -96.597 580.02)"
  }), React.createElement("ellipse", {
    cx: 129.03,
    cy: 584.02,
    rx: 15.42,
    ry: 7.69,
    transform: "rotate(-29.9 -96.597 580.02)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 129.01,
    cy: 583.98,
    rx: 15.02,
    ry: 7.07,
    transform: "rotate(-29.9 -96.625 579.972)"
  }), React.createElement("path", {
    d: "M88 478.23a69 69 0 0 1 16.29-10.37c1.11-.5 2.24-1 3.36-1.46l6.29-2.65z",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 137,
    cy: 570.88,
    rx: 3.31,
    ry: 6.64,
    transform: "rotate(-37.72 -42.464 555.335)"
  }), React.createElement("ellipse", {
    cx: 137,
    cy: 570.88,
    rx: 3.31,
    ry: 6.64,
    transform: "rotate(-37.72 -42.464 555.335)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 137.01,
    cy: 570.87,
    rx: 3.04,
    ry: 6.47,
    transform: "rotate(-37.72 -42.444 555.325)"
  }), React.createElement("path", {
    d: "M105.14 452.7a29.71 29.71 0 0 1 5.38 6.35c.28.44.55.9.82 1.35l1.5 2.52z",
    opacity: 0.3
  }), React.createElement("ellipse", {
    cx: 145.28,
    cy: 581.54,
    rx: 3.31,
    ry: 6.64,
    transform: "rotate(-37.72 -34.188 565.99)"
  }), React.createElement("ellipse", {
    cx: 145.28,
    cy: 581.54,
    rx: 3.31,
    ry: 6.64,
    transform: "rotate(-37.72 -34.188 565.99)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 145.29,
    cy: 581.52,
    rx: 3.04,
    ry: 6.47,
    transform: "rotate(-37.72 -34.169 565.981)"
  }), React.createElement("path", {
    d: "M113.42 463.36a30 30 0 0 1 5.38 6.34c.28.45.55.9.82 1.35l1.5 2.53z",
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 113.19,
    cy: 463.22,
    r: 1.34
  }), React.createElement("circle", {
    cx: 113.19,
    cy: 463.22,
    r: 1.34,
    opacity: 0.3
  })), React.createElement("path", {
    d: "M191.68 561.11c1.79 2.73 3.57 8.8 3.48 9.85s5 6.69 6.42 8.45a35.45 35.45 0 0 1 3.12 5.19l4.73 8.8a47.12 47.12 0 0 0 8.46-3.79l1.7.19a33.93 33.93 0 0 0 3.9-.6c0 .22-.06.44-.08.65-.81 6.57-1.41 12-1.41 12s1.6 5.81 3.83 4l.12-.1c.06.28.12.6.18 1a63.63 63.63 0 0 1 1.13 13.67c-.45 6.77 1 17.07 1 17.07s3.1-.26 7.67-.54c.12.33.25.67.39 1 .44 1.14.93 2.41 1.44 3.67l.09.23c.07.16.13.33.2.49l.13.33.18.43.21.5.13.33.28.67a2.14 2.14 0 0 1 .1.22c.08.18.15.37.23.55l.1.21.24.55.07.16c.32.72.63 1.38.92 1.94v.07l.25.47v.07l.25.44c.08.15.17.28.24.4 2 3.08 3.48 8.62 3.48 8.62l1.87 11.35s.39 2.75.56 5.22c.06.9.09 1.76.07 2.44 0 .19 0 .58.05 1.14a1.79 1.79 0 0 1 0 .24c.17 2.06.6 6 1.14 10.59.11.93.22 1.88.34 2.85a126.3 126.3 0 0 0 .31 17.2s-1.34 21.38-1 23.4c.21 1.17-.78 3.79-1.65 6l-.27-.24s-4.77 5-4.68 10.76.54 13.55.54 13.55.44 3.16-.54 4 0 5.28 0 5.28 8.38 7.68 15.42-.64c0 0 1.38-4.76.81-7.82-.05-.25-.1-.57-.16-1a91.67 91.67 0 0 0-.8-9.94l-.82-6c.88-.09 2.22-4.84 1.6-6s.54-6 .54-6l2.1-6.49c.09.21.18.42.27.65v.09a2.33 2.33 0 0 1 .11.28v.09l.39 1 .12.35v.07c.13.36.25.73.36 1.1l.1.34v.08c.1.36.19.7.26 1v.07l.06.29v.4a.28.28 0 0 1 0 .09 3.89 3.89 0 0 1 0 .47.61.61 0 0 1 0 .14v.83a15.09 15.09 0 0 0 .64 6.86v.1c0 .1.07.19.11.28a.87.87 0 0 0 .07.17 3.92 3.92 0 0 0 .16.36 4.33 4.33 0 0 0 .39.63l-.27 23s3.3 5.08 10.88 4 6.51-9.33 5.44-10.65-1.6-7.12-1.6-7.12-1.34-9.51-2.23-12.94a4.09 4.09 0 0 0-2.08-3c-.34-1.08-.82-2.08-.86-2.23a28 28 0 0 1-1.94-4.6 3.61 3.61 0 0 1-.12-1.65 5.4 5.4 0 0 0 0-1.08V727.01v-.32c-.23-5.76-1.58-21.66-2.31-29.92 1.18-6.07 1.94-10.85 1.77-11.47-.45-1.58.71-13.11.71-13.11s1.43-11.7 3.39-15.4c1.3-2.44 3.85-11.63 5.42-17.56.1-.37.19-.73.28-1.08a12.3 12.3 0 0 0 4.82-1.15s-1.16-10.21 1.69-15.49c2-3.62 3.33-19.66 3.37-30.2v-1.53c2.37 2 4 4.72 4.58 4.45A129.73 129.73 0 0 0 311 583.9c6.5-5.28-11.68-34.94-13.73-37.22S291 518 291 518a5.18 5.18 0 0 0 2.5 1.76c1.34.26 3.83 2.11 6.6 4.42s15.42 0 15.42 0c9.19.44 10.88-7.39 10.88-7.39s4.55-10.56 4.73-14.34 7-19 7-19a14.79 14.79 0 0 0-6.14-5.52c.5-1.63 1.22-3 2.22-3.45 2.85-1.24 34.59-13 23.35-17s-28.53 9-28.53 9-.89.3-2.31 3.2c-.75 1.53-1.72 4.13-2.48 6.25-.08.22-.16.44-.23.65l-.5.05s-4.1 8.89-4.1 11-5 12.23-5 12.23-2.49 2.56-1.6 4.58-2.01 1.56-2.01 1.56l-3.93-3.08s-3.38-2.2-5-2.55-4.37-3.25-4.37-3.25-3.21-2.12-2.94-2.47-1.78-2-2.94-2.55-1.7-1.67-2.85-3.78-2.95-.53-3.84-.88-12 1.05-13.1 1.32-5.09.35-7.14-1.06a5.36 5.36 0 0 0-4.51-.5 23.8 23.8 0 0 1-1.05-2.72 4.11 4.11 0 0 1-.13-.48 19.18 19.18 0 0 0 11.6-17.56 18.92 18.92 0 0 0-4.75-12.57c-.27-.3-.55-.6-.84-.89 1.08-.52 2.65-1.65 2.67-2.93a1.85 1.85 0 0 0-.52-1.32c-.4-.45-1-.68-1.42-1.12a2.47 2.47 0 0 1-.58-1.77c0-.81.21-1.68.22-2.52a3.64 3.64 0 0 0-.1-1 3.86 3.86 0 0 0-3.28-2.57.25.25 0 0 0 0 .07 6.23 6.23 0 0 0-1.77-.08c-2.06.22-4 1.15-6 1.38-3.19.35-6.28-1-9.39-1.82s-6.88-.84-9 1.52-2 6.36-4.66 8.06c-1.23.79-2.79.87-4.12 1.47a8.48 8.48 0 0 0-3.49 3.28 17 17 0 0 0-2.63 11c.22 2.08.83 4.11 1.08 6.19a18 18 0 0 1-.43 6.49c-.57 2.19-1.78 4.49-4 5.18a6.79 6.79 0 0 0-1.48.5c-1.26.77-1.09 2.6-.77 4l1.32 5.87c-1.25.94-3.18.54-4.39 1.52a3.63 3.63 0 0 0-1 1.59 8.6 8.6 0 0 0 2 8.92c0 .11-.08.22-.11.33s-.14.5-.2.77c-1.07 5.11-.71 5.72-1.43 6.6a60.76 60.76 0 0 1-4.36 6.58 7.1 7.1 0 0 0-1.61 4.23s-5.35 7.83-7 8.71-4.28 6.86-4.28 6.86-4.19 2.73-4.19 5.81a50.72 50.72 0 0 1-.8 7.65c-.1.49.61 5.95 2.39 8.68zm15.32-4.75c.8-1.24 0-3.61 0-3.61s5.26-6.87 6-10.83 5.53-6.59 5.53-6.59 2.5-1 2.67 0 .63 3.07.63 3.07-.45 5.11 1.43 7.13 2.16 10.56 2.16 10.56 3 8.45 1.58 11.09c-.5.93-1.27 5.52-2.06 11.07-.7-.11-1.36-.19-2-.24-.57-.53-4.18-3.85-6.06-4.5-2.06-.7-4-6.51-4.11-7.83s-1.87-5.72-3.74-6.51-2.81-1.58-2.03-2.81z",
    transform: "translate(-28 -113.04)",
    fill: "url(#prefix__c)"
  }), React.createElement("path", {
    d: "M310 370.96a14.38 14.38 0 0 0-14.41-6.76v10.28h6.24l4.92-1.27z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M310 370.96a14.38 14.38 0 0 0-14.41-6.76v10.28h6.24l4.92-1.27z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M295.17 366.89l7.64 5.36s.07-1.08.26-2.54c.38-2.77 1.24-6.93 3.08-7.74 2.81-1.23 34.08-13 23-16.95s-28.1 9-28.1 9-.88.3-2.28 3.2c-.74 1.52-1.7 4.12-2.44 6.23-.67 1.92-1.16 3.44-1.16 3.44z",
    fill: "#ae6e79"
  }), React.createElement("path", {
    fill: "#4c4981",
    d: "M234.07 375.14l-.87-.41-2.45 2.79 2 4.26 3.41-1.36-.79-3.41-1.3-1.87z"
  }), React.createElement("path", {
    d: "M245.64 624.57s2.2-.27 3.08 3.16 2.19 12.91 2.19 12.91.53 5.8 1.58 7.11 2.11 9.58-5.36 10.63-10.71-4-10.71-4l.26-23zM219.6 625.6s-4.7 5-4.61 10.74.53 13.52.53 13.52.43 3.16-.53 4 0 5.27 0 5.27 8.26 7.67 15.19-.65c0 0 1.36-4.74.79-7.8s-2.1-16.84-2.1-16.84z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M208 520.58s4.75 13.26 6.77 16.34 3.42 8.6 3.42 8.6l1.81 11.33a63.08 63.08 0 0 1 .61 7.65c-.09 2.54 4.57 39.69 4.57 39.69l7.38 9.4s3.25 6.59 2.72 9.31.35 7.11 1.4 8.43c0 0 .18 8.61.44 10.54s-1 7.38 0 8.34 13.88.53 14.23-1-1.58-9.22-1.58-9.22l-1.14-7.38s-2.29-4-1.76-5.36-1-4.39-1.05-4.65-2.46-4.57-2-6.24-2.73-37.06-2.73-37.06l-9-63.5z",
    fill: "#ae6e79"
  }), React.createElement("path", {
    d: "M208 520.58s.72 2 1.71 4.62c1.57 4.14 3.82 9.84 5.06 11.72 2 3.07 3.42 8.6 3.42 8.6l1.81 11.33a63.05 63.05 0 0 1 .61 7.64c0 1 .67 7.42 1.54 14.81 1.33 11.3 3 24.89 3 24.89l7.38 9.4s.37.75.84 1.85c.92 2.16 2.23 5.65 1.88 7.46-.53 2.72.35 7.11 1.4 8.43 0 0 .18 8.61.44 10.54s-1 7.37 0 8.34 13.88.53 14.23-1-1.58-9.22-1.58-9.22l-1.14-7.38s-2.28-4-1.76-5.36-1-4.39-1.05-4.65-2.46-4.57-2-6.24c.33-1.27-1.42-22.08-2.27-31.94-.27-3.1-.45-5.12-.45-5.12l-7.79-54.62-.62-4.41-.64-4.47z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M215.87 652.67c-.09 1 12.38 2.37 14.16 1.32s0-14.14 0-14.14l-.81-6c.87-.09 2.19-4.83 1.58-6s.53-6 .53-6l2.07-6.48 1.26-4c2-4.53 5-17.45 6.87-27.11 1.16-6.06 1.91-10.83 1.74-11.44-.44-1.58.7-13.09.7-13.09s1.41-11.68 3.34-15.37c1.28-2.44 3.79-11.61 5.34-17.53.79-3 1.34-5.22 1.34-5.22s-13.28-1.11-21.32-1.5c-3.71-.18-6.31-.2-6 .1s.37 1.91.36 4.24c0 6-.88 16.62-1.76 19.47-1.23 4-2.46 15.81-1.94 16.95s.36 8.78.36 8.78a39 39 0 0 0-1.54 9.54 128.43 128.43 0 0 0 .3 17.16s-1.31 21.35-1 23.36-2.81 8.35-2.81 9.58-.88 9.57-.88 9.57-1.76 12.84-1.89 13.81zM208.93 396.14l1.52 1.62 1 1.06 5.75 6.18 14.8 1.67 7.88-2.11 2-.52s0-4-.36-8.72c-.5-6.1-1.7-13.5-4.56-15.52a11.34 11.34 0 0 1-3.35-4.23 24 24 0 0 1-1.43-3.55c-.06-.16-.1-.31-.15-.46a39.59 39.59 0 0 1-1.4-6.51s-1.9-1-4.52-2.28c-6.88-3.2-18.75-7.64-14.62 2.28a36.74 36.74 0 0 1 1.55 4.45c.06.22.12.44.17.66 1.38 5.51.47 8.86-.56 10.7a7.36 7.36 0 0 1-.59.92 4.86 4.86 0 0 1-1 1l-1.71 10.85-.14.9z",
    fill: "#ae6e79"
  }), React.createElement("path", {
    d: "M211.48 365.57c.78 1.88-.38-1.53 0 0 3.13 2.23 10.51 8.57 14.65 8.57 2.8 0 3.64-.51 6-1.59a39.36 39.36 0 0 1-1.55-7s-24.81-13.68-19.1.02z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M205.17 354.03a19.13 19.13 0 0 0 17.14 19 18.85 18.85 0 0 0 2 .11 19.15 19.15 0 1 0-19.14-19.15z",
    fill: "#ae6e79"
  }), React.createElement("path", {
    d: "M202.43 438.96l2.72 7.11s2.23.1 5.69.21c11.68.37 37.43.84 38.58-2.14a7.41 7.41 0 0 0 .4-2.37c.15-4.57-2-11.6-2-11.6s-1.23-14-1.23-14.66 1.07-10.55 1.07-10.55l-2.1-7.9-5.89-4.1s-2.64 4.05-4.22 4.39a11.12 11.12 0 0 0-3.68 2.29s-5.18 3.16-6.85 1.4-14.67-9.48-14.67-9.48l-6.85 7.55z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M202.43 439.96l2.72 7.12s2.23.1 5.69.2h.34c1.49 0 3.2.1 5 .14 9.28.21 22.07.27 28.76-.71 2.51-.36 4.15-.87 4.43-1.58a5.36 5.36 0 0 0 .31-1.31 8.73 8.73 0 0 0 .09-1c.15-4.58-2-11.6-2-11.6s-1.23-14.06-1.23-14.67 1.05-10.45 1.05-10.45l-2.1-7.91-4.05-2.83-1.84-1.29a26.41 26.41 0 0 1-2 2.65 5.32 5.32 0 0 1-2.2 1.74 11 11 0 0 0-3.68 2.28s-5.18 3.17-6.85 1.41c-1.28-1.35-9.18-6.18-12.83-8.38l-1.84-1.11-.92 1-5.93 6.54z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M295.17 366.89l7.64 5.36s.07-1.08.26-2.54a15.46 15.46 0 0 1-6.73-6.25c-.68 1.91-1.17 3.43-1.17 3.43z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M268.3 385.07l1.67-.44s2.72 2.9 4.3 3.25 4.92 2.55 4.92 2.55l3.86 3.07s2.9.44 2-1.58 1.59-4.57 1.59-4.57 4.91-10.1 4.91-12.2 4-11 4-11 5.1 9.92 14.41 6.76c0 0-6.77 15.19-6.94 19s-4.66 14.32-4.66 14.32-1.66 7.81-10.71 7.37c0 0-12.47 2.32-15.19 0s-5.19-4.15-6.5-4.41a5.1 5.1 0 0 1-2.46-1.76v-10.47z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M283.93 394.96s-2.19 8.17-.79 9.05zM210.84 447.28c11.68.38 37.43.84 38.58-2.14a7.3 7.3 0 0 0 .4-2.36l-38.17 2zM208 520.58s.72 2 1.71 4.63c4.85-.3 11.27-.61 17.36-.65 2.16 0 4.27 0 6.26.07a47.17 47.17 0 0 1 10.24 1.13 27 27 0 0 0 9.12 1.18c.79-3 1.34-5.22 1.34-5.22s-13.28-1.11-21.32-1.5l-.64-4.47z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M197.69 488.44l1.49 3.16s.21.94.47 2.44a63.36 63.36 0 0 1 1.12 13.63c-.45 6.77 1 17 1 17s32.32-2.72 41.8 0 14.15 0 14.15 0-1.15-10.19 1.66-15.45c1.92-3.61 3.27-19.63 3.32-30.15 0-4.86-.25-8.54-.86-9.29-1.93-2.37-10.18-26.09-10.18-26.09l-1.89.1-5 .27-28.58 1.51-4.49.23-.47 1.45z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M183.46 477.9l-.26 2.81s14.15-4.61 13.44-10.28 0-5 0-5l-11.38 1z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M183.46 477.9l-.26 2.81s14.15-4.61 13.44-10.28 0-5 0-5l-11.38 1zM274.49 397.26a12.58 12.58 0 0 1-5 2.59 3.26 3.26 0 0 0 1.47-.69c1-.72 2-1.5 2.95-2.27a9.34 9.34 0 0 1 2.74-1.89 15 15 0 0 1-2.16 2.26zM274.27 400.96a6.39 6.39 0 0 0-1.09 1.73 7.08 7.08 0 0 0-.31 2.25 7 7 0 0 0 .39 3.19l2.3-5.47c.39-.93.79-1.86 1.27-2.75.2-.39 1.51-2 1.36-2.31-.43-.94-3.49 2.84-3.92 3.36zM211 431.26a7.28 7.28 0 0 1-4.14-1.92c2.34.29 4.55 1.21 6.85 1.69a10.16 10.16 0 0 0 6.37-.59c-2.68 1.29-6.28 1.34-9.08.82zM217.55 415.19a1.59 1.59 0 0 0 1.19-.3q2.63-1.5 5.18-3.14a31.62 31.62 0 0 0 5.08-3.51c-3.49 3.15-6.73 5.81-11.45 6.95zM212.68 433.81a10.91 10.91 0 0 1-2.74-.21 3.7 3.7 0 0 1-2.25-1.49 1.25 1.25 0 0 1 .95.16 16.23 16.23 0 0 0 8.82 1.05 12.61 12.61 0 0 1-4.78.49zM229.32 474.59a28.27 28.27 0 0 0 5.61 1.1 32.91 32.91 0 0 0 4.44-.08l7.2-.46 3.6-.23c.42 0 2.16 0 1.3-.85-.43-.42-2.83-.15-3.45-.17-1.19 0-2.39-.06-3.58-.07q-3.57 0-7.14.15c-2.67.12-5.3.33-7.98.61zM237.64 478.15c1.22-.05 2.8.68 4.05.83a26.12 26.12 0 0 0 4.24.17 23.77 23.77 0 0 0 8.17-1.67c-5.49.28-10.98.48-16.46.67zM253 481.96a12.46 12.46 0 0 0-1.56.43c-3 .87-6.26.11-9.32-.65a5.59 5.59 0 0 0 3.54 2 16.56 16.56 0 0 0 6.9.25c.72-.14 2.52-.4 2.89-1.15.55-1.2-1.75-1.03-2.45-.88zM236 487.58a25.31 25.31 0 0 0-2.69.7c-3.41.84-6.95-.32-10.38-1.1a48.23 48.23 0 0 0-12.56-1.17 11.1 11.1 0 0 1 2.7.89c1 .29 1.95.56 2.93.81a59 59 0 0 0 5.87 1.14 60.66 60.66 0 0 0 12 .53c1.84-.11 5 .08 6.61-.85a7.34 7.34 0 0 0-4.48-.95zM234.75 379.26s-.18 8.09 1.14 11.78c.41 1.15 1.06 3.27 1.76 5.64.78 2.64 1.61 5.59 2.26 7.88l1.08 3.87s3 24.16 3.73 35.67v.6c0 .65.11 1.32.22 2 1.7 11.43 11.57 29.07 14.88 30.48a10 10 0 0 1 2.79 1.91c0-4.86-.25-8.54-.86-9.29-1.93-2.37-10.18-26.09-10.18-26.09l-1.89.1a8.73 8.73 0 0 0 .09-1c.15-4.58-2-11.6-2-11.6s-1.23-14.06-1.23-14.67 1.05-10.45 1.05-10.45l-2.1-7.91-4.05-2.83c-.5-6.1-1.7-13.5-4.56-15.52a11.34 11.34 0 0 1-3.35-4.23c-.56.08.47-.42.47-.42z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M233.2 374.73a5.26 5.26 0 0 1 4.45.5c2 1.41 6 1.32 7 1.06s12-1.67 12.91-1.32 2.63-1.23 3.77.88 1.67 3.25 2.81 3.77 3.16 2.2 2.9 2.55 2.9 2.46 2.9 2.46l-6.41 20.81s4.13 26.35 6.15 28.64 19.93 31.88 13.52 37.15a128.8 128.8 0 0 1-16.07 10.8c-.7.35-3.25-4.39-6.76-5.89s-14.37-21.25-15.08-32.49-3.78-36.27-3.78-36.27-3.77-13.7-5.09-17.39-1.14-11.78-1.14-11.78z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M197.69 488.44l1.49 3.16s.21.94.47 2.44a1.37 1.37 0 0 0 .76-.33c2.2-1.76 15.11-15 15.72-26.79.45-8.68.24-16.16.1-19.49 0-1.05-.09-1.68-.09-1.82s-10-12.12-8.87-16.42 3.73-27.35 3.73-27.35l.39-3 .66-5.09 1.6-12.34-1.65.39a4.86 4.86 0 0 1-1 1l-1.71 10.85-5.93 6.54-1 39.78 2.72 7.12s2.23.1 5.69.2h.34z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M192.15 422.75s2.47-1 2.64 0 .62 3.07.62 3.07-.41 5.14 1.4 7.14 2.19 10.51 2.19 10.51 3 8.43 1.55 11.07c-.5.95-1.29 5.75-2.09 11.49-.5 3.58-1 7.54-1.44 11.14-.79 6.55-1.39 12-1.39 12s1.58 5.8 3.78 4 15.11-15 15.72-26.79c.43-8.26.26-15.45.11-19-.06-1.5-.11-2.35-.11-2.35s-10-12.12-8.87-16.42 3.74-27.29 3.74-27.29l.46-3.56.49-3.82.11-.84 1.59-12.24c-.28.07-10.13 2.3-11.43 3.59s-9.31 3.16-9.31 3.16a7 7 0 0 0-5 5.12 7.84 7.84 0 0 0-.2.77c-1.05 5.1-.7 5.71-1.41 6.59s6.85 22.66 6.85 22.66z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M197 477.17c3.61-.71 8.92-2.37 8.8-6-.11-3.43-4.24-4.67-7.36-5.11-.53 3.55-1.03 7.51-1.44 11.11z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M185.83 475.35c.14.31.74.58 1.53.81a41 41 0 0 0 5.85.95s12.21-1 12-6.5c-.12-4-5.64-5-8.74-5.27-1.22-.1-2.06-.08-2.06-.08s-9.11 8.95-8.58 10.09z",
    fill: "#ae6e79"
  }), React.createElement("path", {
    d: "M185.83 475.35c.14.31.74.58 1.53.81 3.19-4.26 7.63-9.72 9.8-10.2 0 0-.25-.25-.66-.62-1.22-.1-2.06-.08-2.06-.08s-9.14 8.95-8.61 10.09z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M188.91 399.56l-3.6.53a62.39 62.39 0 0 1-4.31 6.58 7.17 7.17 0 0 0-1.58 4.22s-5.27 7.82-6.94 8.69-4.21 6.85-4.21 6.85-4.13 2.73-4.13 5.8a51 51 0 0 1-.79 7.64c-.09.44.61 5.89 2.37 8.61s3.51 8.78 3.43 9.84 4.91 6.67 6.32 8.43a34.86 34.86 0 0 1 3.07 5.18l4.66 8.78s9.83-14.49 13.44-15.28c0 0-4-3.87-6.06-4.57s-4-6.5-4-7.81-1.85-5.71-3.69-6.5-2.81-1.58-2-2.81 0-3.6 0-3.6 5.18-6.85 5.88-10.81 5.45-6.58 5.45-6.58l2.72-6.68z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M175.84 432.35a11.31 11.31 0 0 0-7.08-2.69 8.67 8.67 0 0 1 4.63 1.81 10.24 10.24 0 0 1 1.29 1.64c.42.59 3.81 4.91 4.35 4.23.8-1.01-2.51-4.38-3.19-4.99zM183.8 428.19a3 3 0 0 1-2.51-1.78 9.94 9.94 0 0 1-.78-3.11 45.93 45.93 0 0 0-1.09-5.34 3.49 3.49 0 0 1-.18-1.11 3.18 3.18 0 0 1 .34-1.07 7.17 7.17 0 0 1 .77-1.6c.65.74.83 2.39 1.1 3.35.33 1.2.64 2.39.92 3.6.15.6 1.34 7.06 1.43 7.06zM186.91 392.73a7.53 7.53 0 0 0 1.21 1.25c1.41 1.14 3.34 2.1 3.52 3.9a4.35 4.35 0 0 0 .21 1.74c.46.78 1.6.72 2.49.56a4.28 4.28 0 0 0 2.1-.77c.95-.81 1-2.24 1.75-3.25a4.42 4.42 0 0 1 3.56-1.59c1.34-.05 2.68.25 4 .32a11.09 11.09 0 0 0 2.57-.18 8.33 8.33 0 0 0 .84-.17 11 11 0 0 0 1.75-.6 7.28 7.28 0 0 0 .85-.4 11.45 11.45 0 0 0 2.48-1.72 6.17 6.17 0 0 0 2.3-4.66 29.68 29.68 0 0 0-.75-3.2c-.54-3.1 1.52-6 3.76-8.25.89-.88 1.84-1.74 2.73-2.64a13.22 13.22 0 0 0 3.21-4.58 13.94 13.94 0 0 0 .58-5.72 37.57 37.57 0 0 1-.17-5.9c.66-7 6.62-12.33 12.58-15.24l.26-.14a19.14 19.14 0 1 0-25.74 28c.06.22.12.44.17.66 1.38 5.51.47 8.86-.56 10.7-.28.07-10.13 2.3-11.43 3.59s-9.31 3.16-9.31 3.16a7 7 0 0 0-4.96 5.13z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M240.1 336.4c-.4-.45-1-.68-1.39-1.12-1.25-1.35 0-3.55-.46-5.33-.49-2-2.91-2.84-4.94-2.63s-3.92 1.14-5.95 1.37c-3.14.35-6.19-1-9.25-1.81s-6.77-.84-8.89 1.51-2 6.35-4.6 8.05c-1.21.78-2.74.86-4.05 1.46a8.54 8.54 0 0 0-3.44 3.28 17.19 17.19 0 0 0-2.59 11c.22 2.08.82 4.11 1.06 6.19a18.07 18.07 0 0 1-.42 6.47c-.56 2.19-1.76 4.49-3.91 5.17a6.62 6.62 0 0 0-1.46.5c-1.24.77-1.07 2.6-.76 4l1.31 5.86c-1.23.94-3.14.54-4.33 1.52a3.62 3.62 0 0 0-1 1.58 8.64 8.64 0 0 0 2.57 9.49c1.4 1.14 3.34 2.1 3.52 3.9a4.13 4.13 0 0 0 .21 1.73c.46.79 1.59.73 2.49.57a4.35 4.35 0 0 0 2.09-.78c1-.8 1-2.24 1.75-3.25a4.45 4.45 0 0 1 3.56-1.59c1.35 0 2.68.26 4 .32a11.89 11.89 0 0 0 8.49-3.06 6.16 6.16 0 0 0 2.3-4.67 27.81 27.81 0 0 0-.75-3.19c-.53-3.1 1.53-6 3.76-8.26s4.85-4.27 5.95-7.21c1.35-3.66 0-7.74.4-11.62.66-7 6.62-12.33 12.59-15.25 1.42-.71 3.68-2.44 2.14-4.2z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M193.13 396.71c1-.8 1-2.24 1.75-3.25a4.45 4.45 0 0 1 3.56-1.59c1.35 0 2.68.25 4 .32a11.87 11.87 0 0 0 8.49-3.07 6.17 6.17 0 0 0 2.3-4.66 30.25 30.25 0 0 0-.75-3.2c-.54-3.1 1.52-6 3.76-8.25s4.85-4.27 5.94-7.22c1.36-3.65 0-7.73.41-11.61.66-7 6.62-12.34 12.58-15.25 1.4-.68 3.65-2.42 2.11-4.17-.39-.45-1-.68-1.39-1.12-1.24-1.35 0-3.56-.46-5.33a2.75 2.75 0 0 0-.45-1 3.79 3.79 0 0 1 3.24 2.56c.44 1.78-.79 4 .46 5.33.4.44 1 .67 1.39 1.12 1.54 1.76-.72 3.49-2.11 4.17-6 2.91-11.93 8.26-12.59 15.25-.37 3.88.95 8-.4 11.61-1.1 2.95-3.72 5-5.95 7.22s-4.29 5.16-3.76 8.26a27.81 27.81 0 0 1 .75 3.19 6.14 6.14 0 0 1-2.3 4.66 11.85 11.85 0 0 1-8.49 3.07c-1.35-.07-2.68-.36-4-.32a4.45 4.45 0 0 0-3.56 1.59c-.72 1-.8 2.45-1.75 3.25a4.35 4.35 0 0 1-2.09.78c-.9.16-2 .22-2.49-.57a2 2 0 0 1-.2-1 4.1 4.1 0 0 0 2-.77z",
    opacity: 0.1
  }));
};

UndrawFollowing.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawFollowing;